import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import AboutUsPage from './pages/AboutUsPage';
import ContactUsPage from './pages/ContactUsPage';
import LandingPage from './pages/LandingPage';
import ApplicationPage from './pages/ApplicationPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import TrademarkRegistration from './pages/TrademarkRegistration';
import CopyrightRegistration from './pages/CopyrightRegistrationNew';
import BusinessFormation from './pages/BusinessFormationNew';
import TrademarkSearch from './pages/TrademarkSearchNew';
import AmazonBrandRegistry from './pages/AmazonBrandRegistryNew';
import ScrollToTop from './components/ScrollToTop';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/lp" element={<LandingPage />} />
          <Route path="/application/main" element={<ApplicationPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/trademark-registration" element={<TrademarkRegistration />} />
          <Route path="/copyright-registration" element={<CopyrightRegistration />} />
          <Route path="/business-formation" element={<BusinessFormation />} />
          <Route path="/trademark-search" element={<TrademarkSearch />} />
          <Route path="/amazon-brand-registry" element={<AmazonBrandRegistry />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
